import React, {useState, useEffect} from "react";
import {
    Form,
    Input,
    Button,
    Card,
    Select,
    DatePicker,
    Popconfirm,
    notification,
    Radio,
    Upload,
    message,
    Checkbox, Popover, InputNumber, Tooltip
} from 'antd';
import jsonfile from '../voucher.json'
import {AllCurrency, CisUI} from '../../../../util/CISUI'
import 'react-smart-data-table/dist/react-smart-data-table.css'
import Config, {fileserver} from "../../../../util/config";
import axios from "../../../../util/Api";
import { useHistory } from "react-router-dom";
import SelectData from "../../../../util/selectdata";
import moment from "moment";
import IntlMessages from "../../../../util/IntlMessages";
import {PlusCircleOutlined, UploadOutlined} from "@ant-design/icons";
import CreateCustomerModal from "./components/CreateCustomerModal";
import CreateVendorModal from "./components/CreateVendorModal";
import {showFileURL} from "../../../../util/FileUtils";

const {Option} = Select;
const {TextArea} = Input;

const MVoucherEdit = (props) => {

    const formRef = React.createRef();

    const [loading, setLoading] = useState([]);

    const [state, setState] = useState({
        data: [],
        rows: []
    })

    const [loaded, setLoaded] = useState(false);
    const [vendor, setVendor] = useState([]);
    const [podata, setPOdata] = useState([]);
    const [mdata, setMdata] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [accounts, setAccount] = useState([]);
    const [bankaccounts, setBankAccounts] = useState([]);
    const [isCash, setIsCash] = useState(false);
    const [cashaccount, setCashAccount] = useState([]);
    const [mainaccount, setMainAccount] = useState([]);
    const [accountchild, setChildAccount] = useState([]);
    const [subaccount, setSubAccount] = useState([]);
    const [voucherNo, setVoucherNo] = useState("");
    const [filteredBankAcocunt, setFilteredBankAccount] = useState([]);
    const [currency, setCurrency] = useState("GHC");
    const [conversion_rate, setConversionRate] = useState(0.00);
    const [totalInGHC, setTotalInGHC] = useState(0.00);
    const [isShowAddButton, setIsShowAddButton] = useState(false);
    const [buttonURL, setButtonURL] = useState('');
    const [beneficiaryData, setBeneficiaryData] = useState({
        department: [],
        users: [],
        ministry: [],
        pentsos: [],
        subsector : [],
        committee: [],
        area: [],
        district: [],
        local: [],
        individuals: []
    });

    const [checkStatus, setCheckStatus] = useState(0);

    const [doc, setDoc] = useState({});
    const [selectedSegment, setSelectedSegment] = useState([]);

    const [voucherType, setVoucherType] = useState("Payment");
    const [bankAccountBalance, setBankAccountBalance] = useState(0.00);
    const [isCIT, setIsCIT] = useState(false);
    const [customerModalVisible, setCustomerModalVisible] = useState(false);
    const [vendorModalVisible, setVendorModalVisible] = useState(false);
    const [addModalRowIdx, setAddModalRowIdx] = useState(null);
    const [showChequeCleared, setShowChequeCleared] = useState(true);

    const onChangeRadio = e => {
        console.log('radio checked', e.target.value);
        setVoucherType(e.target.value);
        let newRowData = [];
        state?.rows?.map((item, index) => {
            newRowData.push({
                ...item,
                account_id: null,
                sub_account_id: null
            })
        })
        
        setState({
            rows: newRowData
        })
    };

    const [bill, setBill] = useState(
        {
            totalReceipt : 0,
            totalPayment : 0
        }
    );

    const BankName = SelectData("banknames");
    const Benificiary = SelectData("accountbenificary");
    const [benificiariesData, setBenificiaryData] = useState([]);
    const PaymentMethod = SelectData("paymentmethod");
    const BankAccount = SelectData("bankaccount");
    // const Area = SelectData("allarea");
    // const District = SelectData("alldistrict");
    // const Local = SelectData("alllocal");

    let BenificaryData = [];

    const onBenificaryChange = (e) => {
        //setBenificiaryselected(e.target.value);
        console.log("Selected : ", e);
        if (e === 2) {
            BenificaryData = customer;
            setBenificiaryData(customer);
        } else if (e === 3) {
            BenificaryData = vendor;
            setBenificiaryData(vendor);
        } else if (e === 4) {
            BenificaryData = employee;
            setBenificiaryData(employee);
        } else if (e === 5) {
            BenificaryData = accounts;
            setBenificiaryData(accounts);
        } else if (e === 6) {
            BenificaryData = beneficiaryData.department;
            setBenificiaryData(beneficiaryData.department);
        } else if (e === 7) {
            BenificaryData = beneficiaryData.area;
            setBenificiaryData(beneficiaryData.area);
        } else if (e === 8) {
            BenificaryData = beneficiaryData.users;
            setBenificiaryData(beneficiaryData.users);
        } else if (e === 9) {
            BenificaryData = beneficiaryData.users;
            setBenificiaryData(beneficiaryData.users);
        } else if (e === 10) {
            // console.log(e);
            // console.log(beneficiaryData.ministry);
            BenificaryData = beneficiaryData.ministry;
            setBenificiaryData(beneficiaryData.ministry);
        } else if (e === 11) {
            BenificaryData = beneficiaryData.pentsos;
            setBenificiaryData(beneficiaryData.pentsos);
        } else if (e === 12) {
            BenificaryData = beneficiaryData.district;
            setBenificiaryData(beneficiaryData.district);
        } else if (e === 13) {
            BenificaryData = beneficiaryData.local;
            setBenificiaryData(beneficiaryData.local);
        }
        else if (e === 14) {
            BenificaryData = beneficiaryData.committee;
            setBenificiaryData(beneficiaryData.committee);
        }
        else if (e === 15) {
            BenificaryData = beneficiaryData.subsector;
            setBenificiaryData(beneficiaryData.subsector);
        }
        else if (e === 17) {
            BenificaryData = beneficiaryData.individuals;
            setBenificiaryData(beneficiaryData.individuals);
        }

        form.setFieldsValue({
            benificiary_id: null
        });

    }

    const [polist, setPolist] = useState({
        po_id : 0,
        po_number : "",
        date: moment(),
        due_date: moment(),
        reference_no: "",
        company: "",
        company_id: null,
        benificiary_id: null,
        vendor_id: null,
        vendor: "",
        payable_id: null,
        fund_program_id : null,
        func_expense_id : null,
        amount : 0,
        description : "",
        remark : "",
        status : 0,
        approved_by : "",
        approved_at : "",
    });

    const onBankChange = (value) => {
        // const vl = value+Math.floor(Math.random() * 900000);
        // form.setFieldsValue({reference_no : vl});
        
        let vl = voucherNo;
        const bank = BankName.filter((item)=> item.bank_id === value);
        console.log("Bank Selected :"+ value);
        let bank_id = 0;
        if(bank.length > 0) {
            const bk = bank[0]
            vl = bk.id+vl;
            bank_id = bk.bank_id;
            if(bank_id > 0) {
                let bankAccountD = bankaccounts.filter(item => item.bank_id === bank_id);
                if(bankAccountD.length > 0) {
                    setFilteredBankAccount(bankAccountD);
                }
                else {
                    setFilteredBankAccount([]);
                }
            }
            else {
                setFilteredBankAccount([]);
            }
        }
        
        // form.setFieldsValue({reference_no : vl, bank_account_id: null});
        form.setFieldsValue({bank_account_id: null})
    }

    const userID = props.match.params.id;
    let userData = [];
    // console.log("Userid : "+props.match.params.id);
    let isEdit = 0;
    if (userID > 0) {
        isEdit = 1;
    }

    let Title = jsonfile.addtitle;
    let endpoint = jsonfile.urls.many_voucher_edit;
    let redirectto = "../" + jsonfile.urls.list;

    if (isEdit === 1) {
        //userData = RemoteJson();
        Title = jsonfile.edittitle;
        endpoint = jsonfile.urls.many_voucher_edit + "/" + userID;
        redirectto = "../../vendor/newbillt?po="+userID;

        // console.log("selected : "+ JSON.stringify(company));
        //console.log("address : "+ company.address_line_1+", "+company.address_line_2);
        //document.getElementById("input_com_address").value = "Test";
    }

    let Vendors = [];
    // const Companies = SelectData("company/companylists");

    const [form] = Form.useForm();
    const history = useHistory();

    useEffect(() => {
        // const comID = CisUI().getUserInfo('com_id');
        // if(comID > 0) {
        //     onCompanyChangeForComapny(comID);
        // }
        OrderDetails();
    }, []);

    const onCompanyChangeForComapny = value => {
        console.log("selected : "+ value);
        if(value > 0) {
            const company = value;
            // document.getElementById("loader").style.display = "block";
            axios.get("billentrydata?com_id="+value)
                .then((res) => {
                    console.log(res.data);
                    if(res.data.status === 1) {
                        setChildAccount(res.data.child_account);
                        setVendor(res.data.vendor);
                        setAccount(res.data.account);
                        setBankAccounts(res.data.bank);
                        setEmployee(res.data.employee);
                        setCustomer(res.data.customer);
                        setCashAccount(res.data.cashaccount);
                        setDoc(res.data.doc_class);
                        setSelectedSegment(res.data.doc_class[1]);
                        setMainAccount(res.data.main_account);
                        setBeneficiaryData({
                            department: res.data.department,
                            users: res.data.users,
                            ministry: res.data.ministry,
                            pentsos: res.data.pentsos,
                            subsector: res.data.subsector,
                            committee: res.data.committee,
                            area: res.data.area,
                            district: res.data.district,
                            local: res.data.local,
                            individuals: res.data.individuals
                        });
                        OrderDetails(res.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // document.getElementById("loader").style.display = "none";
                });

            formRef.current.setFieldsValue({
                vendor: "",
                accounts_payable: "",
                accounts_id: ""
            });
        }
    }

    // if(loaded) {
    //     OrderDetails();
    // }

    const OrderDetails = async (resp = null) => {
        // document.getElementById("loader").style.display = "block";
        return await axios.get(jsonfile.urls.viewEdit + "/" + userID)
            .then((res) => {
                if(res.data.status === 1) {
                    const podata = res.data.data;
                    //onCompanyChange(podata.company_id);
                    let  trxType = "";
                    setConversionRate(res?.data?.conversion_rate)

                    // console.log(podata);

                    if(podata.debit > 0) {
                        // console.log("Reciept");
                        setVoucherType("Receipt");
                        trxType = "Receipt";
                    }
                    else {
                        setVoucherType("Payment");
                        trxType = "Payment";
                    }

                    let head_id = podata.bank_account_id;

                    if(podata.type === 1) {
                        head_id = podata.head2_id;
                        setIsCash(true);
                    }

                    setCheckStatus(podata?.checque_status);
                    form.setFieldsValue({
                        date: moment(podata.date, 'YYYY-MM-DD'),
                        bank_id: podata.bank_id,
                        reference_no: podata.voucher_no,
                        payment_method: podata.type,
                        bank_account_id: head_id,
                        check_no: podata.reference,
                        remark: podata.remark,
                        notes: podata.notes,
                        trx_type: trxType,
                        check_status: podata?.checque_status,
                        // is_cit: podata?.is_cit === 1 ? true : false,
                        currency: podata?.currency,
                        conversion_rate: podata?.conversion_rate,
                    })
                    setShowChequeCleared(podata?.type === 2);
                    setIsCIT(podata?.is_cit === 1 ? true : false)
                    setCurrency(podata?.currency);
                    getBalance(podata?.bank_account_id)

                    // setVendor(res.data.vendors);
                    setPOdata(res.data.data);
                    setMdata(res.data.multi);
                    // let split = podata.voucher_no.split("");
                    // setVoucherNo(split.slice(2, (split.length - 1)).join(""));
                    setVoucherNo(podata.voucher_no)

                    setChildAccount(res.data.child_account);
                    setVendor(res.data.vendor);
                    setAccount(res.data.account);
                    if(podata?.bank_id > 0) {
                        let bank_id = podata?.bank_id;

                        let bankAccountD = res.data.bank.filter(item => item.bank_id === bank_id);
                        if(bankAccountD.length > 0) {
                            setFilteredBankAccount(bankAccountD);
                        }
                        else {
                            setFilteredBankAccount([]);
                        }
                    }
                    else {
                        setFilteredBankAccount([]);
                    }
                    
                    setBankAccounts(res.data.bank);
                    setEmployee(res.data.employee);
                    setCustomer(res.data.customer);
                    setCashAccount(res.data.cashaccounts);
                    setMainAccount(res.data.main_account);
                    setBeneficiaryData({
                        department: res.data.department,
                        users: res.data.users,
                        ministry: res.data.ministry,
                        pentsos: res.data.pentsos,
                        subsector: res.data.subsector,
                        committee: res.data.committee,
                        area: res.data.area,
                        district: res.data.district,
                        local: res.data.local,
                        individuals: res.data.individuals
                    });

                    const child = res.data.child_account;

                    let allrows = [];
                    let totalGHC = 0.00;
                    res.data.multi.map((items, index)=> {
                        let amount = podata?.currency === 'USD' ? items.dollar_amount : items.debit;
                        if(items.credit > 0) {
                            amount = podata?.currency === 'USD' ? items.dollar_amount : items.credit;
                        }

                        if(podata?.currency === 'USD'){
                            totalGHC += items.amount_fc
                        }
                        // console.log("SubAccount: "+JSON.stringify(accountchild));
                        const sub = child[items.account_id] || [];
                        // console.log(JSON.stringify(sub));
                        let e = items.benificiary_type;
                        let BF = [];

                        if (e === 2) {
                            setIsShowAddButton(true);
                            setButtonURL('/crm/newlead');
                            BF = res.data.customer;
                        } else if (e === 3) {
                            setIsShowAddButton(true);
                            setButtonURL('/vendor/newvendorinfo');
                            BF = res.data.vendor;
                        } else if (e === 4) {
                            BF = res.data.employee;
                        } else if (e === 5) {
                            BF = res.data.accounts;
                        } else if (e === 6) {
                            BF = res.data.department;
                        } else if (e === 7) {
                            BF = res.data.area;
                        } else if (e === 8) {
                            BF = res.data.employee;
                        } else if (e === 9) {
                            BF = res.data.users;
                        } else if (e === 10) {
                            BF = res.data.ministry;
                        } else if (e === 11) {
                            BF = res.data.pentsos;
                        } else if (e === 12) {
                            BF = res.data.district;
                        } else if (e === 13) {
                            BF = res.data.local;
                        }
                        else if (e === 14) {
                            BF = res.data.committee;
                        }
                        else if (e === 15) {
                            BF = res.data.subsector;
                        }
                        else if (e === 17) {
                            setIsShowAddButton(true);
                            setButtonURL('/crm/newlead');
                            BF = res.data.individuals;
                        }

                        allrows.push({
                            id: items.id,
                            account_id: items.account_id,
                            sub_account_id: items.sub_account_id,
                            description: items.details,
                            checkno: items.reference,
                            beneficiary_source : items.benificiary_type,
                            beneficiary_id : items.benificiary_id,
                            payment_method : items.type,
                            bank_account_id : items.bank_account_id,
                            // amount: amount,
                            amount: podata?.currency !== 'GHC' ? items.dollar_amount : amount,
                            amount_in_ghc: podata?.currency !== 'GHC' ? items.amount_fc : 0,
                            subaccounts: sub,
                            beneficiary: BF,
                            // files: items.files
                            attachments: items.files
                        })

                        //onBenificaryChange(items.benificiary_type);

                    });
                    setTotalInGHC(totalGHC);
                    setState({rows: allrows})
                    setConversionRate(podata?.conversion_rate)
                    
                    console.log("allrows", allrows)

                    let totalsReceipt = 0
                    let totalsPayment = 0
                    let totalAmount = 0
                    allrows.map((item, idx) => {
                        totalAmount += parseFloat(item.amount);
                    });

                    setBill({
                        totalReceipt : totalAmount
                    });

                    setLoaded(true);

                }
                // document.getElementById("loader").style.display = "none";
            })
            .catch((error) => {
                console.log(error);
                // document.getElementById("loader").style.display = "none";
            });
    }

    const onFinish = (values) => {
        // setLoading({loading: true})
        setLoaded(false);
        let newRows = [];
        let error = 0;
        state.rows.map((items,ind)=>{
            if(items.account_id ===  null || items.sub_account_id === null){
                error = 1;
            }else {
                newRows.push({
                    id: items.id,
                    account_id: items.account_id,
                    sub_account_id: items.sub_account_id,
                    description: items.description,
                    checkno: items.checkno,
                    beneficiary_source: items.beneficiary_source,
                    beneficiary_id: items.beneficiary_id,
                    payment_method: items.payment_method,
                    bank_account_id: items.bank_account_id,
                    amount : currency !== 'GHC' ? items.amount_in_ghc : items.amount,
                    dollar_amount: currency !== 'GHC' ? items.amount : 0.00,
                    conversion_rate: conversion_rate,
                    files : items.files,
                    file_location : items.file_location
                });
            }
        });

        values["items"] = newRows;
        values["summary"] = bill;
        if(error === 1){
            CisUI().showAlert("Alert","warning", "Please select all account and sub-account.")
            setLoaded(true);
            return;
        }
        if (checkStatus === 1) {
            values["checque_status"] = 1;
        } else {
            values["checque_status"] = 0;
        }

        // console.log("check", checkStatus);

        values["is_cit"] = isCIT === true ? 1 : 0;
        // console.log(values);
        // return;
        document.getElementById("loader").style.display = "block";
        axios.post(Config.apiserver + endpoint, values)
            .then(res => {
                console.log(res)
                if (res.data.status === 1) {
                    // CisUI().showAlert("Success","success",res.data.msg);
                    document.getElementById("loader").style.display = "none";
                    history.push("../../entries/mvoucherdetails/"+res?.data?.voucher_no);
                } else {
                    CisUI().showAlert("Alert","warning",res.data.msg);
                    document.getElementById("loader").style.display = "none";
                }
                setLoading({loading: false});
                setLoaded(true);
            })
            .catch(errors => {
                // console.log(errors.response.data.errors);
                setLoading({loading: false});
                setLoaded(true);
                document.getElementById("loader").style.display = "none";
            });
    };

    const ItemCellChange = (idx,cname="") => e => {
        let name = "";
        let value = null;
        if(cname === "") {
            name = e.target.name;
            value = e.target.value;
        }
        else {
            name = cname;
            value = e;
        }

        const rows = [...state.rows];
        // console.log("Index:"+ idx);
        console.log("selectedITems:"+ JSON.stringify(rows[idx]));
        // console.log("Event:"+ name);
        // console.log("EventValue:"+ value);

        if(name === "account_id") {
            const sub = accountchild[parseInt(value)] || [];
            setSubAccount(sub);
            rows[idx] = {
                id: rows[idx].id,
                account_id: value,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno: rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: sub,
                beneficiary: rows[idx].beneficiary,
            };
        }
        else if(name === "sub_account_id") {
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: value,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno: rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary,
            };
        }
        else if(name === "description") {
            //const amount = value * rows[idx].price;
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: value,
                checkno: rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary,
            };
        }
        else if(name === "amount") {
            //CalculateCell();
            //const amount = value * rows[idx].qty;
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno: rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: Number(value),
                amount_in_ghc: conversion_rate !== undefined ? Number((conversion_rate * Number(value)).toFixed(2)) : 0.00,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary,
            };
        }
        else if(name === "checkno") {
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno: value,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary
            };
        }
        else if(name === "beneficiary_source") {
            setIsShowAddButton(false);
            setButtonURL('');
            e = value;
            let BF = [];
            if (e === 2) {
                setIsShowAddButton(true);
                setButtonURL('/crm/newlead');
                BF = customer;
            } else if (e === 3) {
                setIsShowAddButton(true);
                setButtonURL('/vendor/newvendorinfo');
                BF = vendor;
            } else if (e === 4) {
                BF = employee;
            } else if (e === 5) {
                BF = accounts;
            } else if (e === 6) {
                BF = beneficiaryData.department;
            } else if (e === 7) {
                BF = beneficiaryData.area;
            } else if (e === 8) {
                BF = beneficiaryData.users;
            } else if (e === 9) {
                BF = beneficiaryData.users;
            } else if (e === 10) {
                // console.log(e);
                // console.log(beneficiaryData.ministry);
                BF = beneficiaryData.ministry;
            } else if (e === 11) {
                BF = beneficiaryData.pentsos;
            } else if (e === 12) {
                BF = beneficiaryData.district;
            } else if (e === 13) {
                BF = beneficiaryData.local;
            }
            else if (e === 14) {
                BF = beneficiaryData.committee;
            }
            else if (e === 15) {
                BF = beneficiaryData.subsector;
            }
            else if (e === 17) {
                setIsShowAddButton(true);
                setButtonURL('/crm/newlead');
                BF = beneficiaryData.individuals;
            }

            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno : rows[idx].checkno,
                beneficiary_source : value,
                beneficiary_id : null,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: BF
            };
        }
        else if(name === "beneficiary_id") {
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno : rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : value,
                payment_method : rows[idx].payment_method,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary
            };
        }
        else if(name === "payment_method") {
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno : rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : value,
                bank_account_id : rows[idx].bank_account_id,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary
            };
        }
        else if(name === "bank_account_id") {
            rows[idx] = {
                id: rows[idx].id,
                account_id: rows[idx].account_id,
                sub_account_id: rows[idx].sub_account_id,
                doc_class: rows[idx].doc_class,
                selectedsegment: rows[idx].selectedsegment,
                description: rows[idx].description,
                checkno : rows[idx].checkno,
                beneficiary_source : rows[idx].beneficiary_source,
                beneficiary_id : rows[idx].beneficiary_id,
                payment_method : rows[idx].payment_method,
                bank_account_id : value,
                amount: rows[idx].amount,
                amount_in_ghc: rows[idx].amount_in_ghc,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
                attachments : rows[idx].attachments,
                subaccounts: rows[idx].subaccounts,
                beneficiary: rows[idx].beneficiary
            };
        }

        setState({
            rows: rows
        });

        let totalsReceipt = 0
        let totalsPayment = 0
        let totalAmount = 0
        let totalGHC = 0;
        rows.map((item, idx) => {
            totalAmount += parseFloat(item.amount);
            totalGHC += parseFloat(item.amount_in_ghc);
        });

        setTotalInGHC(totalGHC);
        setBill({
            totalReceipt : totalAmount
        });

    };

    // const onPaymentMethodChange = (idx,cname="") => e => {
    const onPaymentMethodChange = (e) => {
        const value = e;
        console.log("mehtod" + value);
        if(value === 1) {
            //document.getElementById("bankaccount").style.display = "block";
            setIsCash(true);
        }
        else {
            //document.getElementById("bankaccount").style.display = "none";
            setIsCash(false);
        }
        if (value === 2) {
            setShowChequeCleared(true);
        } else {
            setShowChequeCleared(false);
        }
        formRef.current.setFieldsValue({
            bank_account_id : null,
            reference : ""
        });
    }

    const onPaymentMethodChange2 = (e) => {}

    const onBankAccountChange = (value) => {
        let ref = "";
        if(!isCash) {
            bankaccounts.map((items, index) => {
                if (items.id === value) {
                    if (items.last_issued_check > 0) {
                        ref = parseInt(items.last_issued_check) + 1;
                    } else {
                        ref = items.starting_check_no;
                    }
                }
            });
            getBalance(value)
            // console.log("RefNo : " + ref);

            form.setFieldsValue({
                check_no: ref,
            });
        }
    }
    
    const getBalance = (value) => {
        axios.get(Config.apiserver+"getbalancebybankaccount/"+value)
            .then((res) => {
                console.log(res.data.data)
                if(res.data.status === 1) {
                    setBankAccountBalance(res.data.data.total_balance);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleAddRow = () => {
        const item = {
            id: 0,
            account_id: null,
            sub_account_id: null,
            doc_class: null,
            selectedsegment: null,
            description: "",
            checkno : "",
            beneficiary_source : null,
            beneficiary_id : null,
            payment_method : null,
            bank_account_id : null,
            amount: 0,
            amount_in_ghc: 0,
            files : [],
            file_location : [],
            attachments : [],
            subaccounts: [],
            beneficiary: []
        };
        setState({
            rows: [...state.rows, item]
        });
    };

    const handleRemoveRow = idx => e => {
        // console.log(idx);
        // console.log(state.rows);
        let totalAmount = 0.00;
        let filteredArray = state.rows.filter((item, index) => index !== idx)
        
        // console.log("filter", filteredArray)
        filteredArray.map((item, idx) => {
            totalAmount += parseFloat(item.amount);
        });
        
        
        setBill({
            totalReceipt : totalAmount
        });
        setState({rows: filteredArray});
    };

    // useEffect(() => {
    //     handleAddRow();
    // }, []);

    const onChangeAccount = (e) => {
        const sub = accountchild[parseInt(e)] || [];
        setSubAccount(sub);
        form.setFieldsValue({
            sub_account_id: null
        });
    }

    const onLineDelete = (lineID) => {
        // setLoading({loading: true});
        // setLoaded(true);
        document.getElementById("loader").style.display = "block";
        axios.delete(Config.apiserver + jsonfile.urls.linedelete+"/"+lineID)
            .then(res => {
                // console.log(res)
                if (res.data.status === 1) {
                    CisUI().showAlert("Success","success",res.data.msg);
                    document.getElementById("loader").style.display = "none";
                    // window.location.reload();
                    const ft = state.rows.filter((item) => item.id !== lineID);
                    ft.map((item, idx) => {
                        totalAmount += parseFloat(item.amount);
                    });
                    
                    setBill({
                        totalReceipt : totalAmount
                    });
                    setState({rows: ft});
                } else {
                    CisUI().showAlert("Alert","warning",res.data.msg);
                    document.getElementById("loader").style.display = "none";
                }
                setLoading({loading: false});
                setLoaded(true);
            })
            .catch(errors => {
                // console.log(errors.response.data.errors);
                document.getElementById("loader").style.display = "none";
                setLoading({loading: false});
                setLoaded(true);
                // document.getElementById("loader").style.display = "none";
            });
    }

    const token = localStorage.getItem('token');
    let formData = new FormData();
    let fileUID = "";
    const uplod = {
        name: 'file',
        action: Config.apiserver+"fileupload",
        method : 'post',
        headers: {
            'Authorization': token,
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
            if (!isJpgOrPng) {
                message.error('You can only upload jpg, png,and pdf file only!');
            }
            return isJpgOrPng;
        },
        onChange(info) {
            formData.append('file', info.file);
            fileUID = info.file.uid;
            console.log("index : "+info.file.uid);
            console.log(JSON.stringify(info));
            if(info.file.status === "done") {
                if (info.file.xhr.status === 200) {
                    console.log("ServerResponse : "+info.file.response);
                    const data = info.file.response;
                    if(data.status === 1) {
                        const list = [...state.rows];
                        let files = list[data.line_index].files || [];
                        let file_location = list[data.line_index].file_location || [];
                        files.push(data.data.id);
                        file_location.push(data.data.location);
                        list[data.line_index].files = files;
                        list[data.line_index].file_location = file_location;
                        setState({rows: list});
                        console.log("Files : "+JSON.stringify(list[data.line_index]));
                        message.success(`${info.file.name} file uploaded successfully`);
                    }

                } else {
                    message.error(`${info.file.name} file upload failed.`);
                }
            }
        }
    }

    const onCheckChange = (e) => {
        console.log(e);
        if (e.target.checked === true) {
            setCheckStatus(1);
        } else {
            setCheckStatus(0);
        }
    }

    var totalAmount = 0;
    // console.log("cis ===", state.rows)

    const handleCustomerCreated = () => {
        const comID = CisUI().getUserInfo("com_id");
        if (comID > 0) {
            axios.get("billentrydata?com_id=" + comID).then((res) => {
                if (res.data.status === 1) {
                    const newCustomerList = res.data.customer || [];
                    const newIndividualsList = res.data.individuals || [];
                    setCustomer(newCustomerList);
                    setBeneficiaryData((prev) => ({
                        ...prev,
                        customer: newCustomerList,
                        individuals: newIndividualsList
                    }));
                    setState((prevState) => {
                        const list = prevState.rows.map((row) => {
                            if (row.beneficiary_source === 2) {
                                return {...row, beneficiary: [...newCustomerList]};
                            }
                            if (row.beneficiary_source === 17) {
                                return {...row, beneficiary: [...newIndividualsList]};
                            }
                            return row;
                        });
                        return {...prevState, rows: list};
                    });
                }
            });
        }
    };

    const handleVendorCreated = () => {
        const comID = CisUI().getUserInfo("com_id");
        if (comID > 0) {
            axios.get("billentrydata?com_id=" + comID).then((res) => {
                if (res.data.status === 1) {
                    const newVendorList = res.data.vendor || [];
                    setVendor(newVendorList);
                    setBenificiaryData((prev) => ({...prev, vendor: newVendorList}));
                    // Update ALL rows with vendor source
                    setState((prevState) => {
                        const list = prevState.rows.map((row) => {
                            if (row.beneficiary_source === 3) {
                                return {...row, beneficiary: [...newVendorList]};
                            }
                            return row;
                        });
                        return {...prevState, rows: list};
                    });
                }
            });
        }
    };

    const handleCIT = (e) => {
        setIsCIT(e.target.checked)
    }
    
    const formField = (

        <>
            <div className="row">

                <div className="col-md-3">
                    <Form.Item
                        name="voucher_type"
                        label="Voucher Type"
                        initialValue={voucherType}
                        rules={[
                            {
                                required: true,
                                message: "Select a voucher type"
                            },
                        ]}
                    >
                        <Radio.Group name={"trx_type"} onChange={onChangeRadio}>
                            <Radio value={"Payment"}>Payment</Radio>
                            <Radio value={"Receipt"}
                                   style={voucherType === 'Receipt' ? {color: "green"} : {}}>Receipt</Radio>
                        </Radio.Group>

                    </Form.Item>
                </div>

                <div className="col-md-3">
                    <Form.Item
                        name="date"
                        label="Date"
                        initialValue={polist.date}
                        rules={[
                            {
                                required: true,
                                message: "Select a date"
                            },
                        ]}
                    >
                        <DatePicker disabledDate={(current) => current.isAfter(moment())} format={CisUI().dateFormat}
                                    format={CisUI().dateFormat} className="gx-mb-3 gx-w-100"
                                    placeholder="Date"/>
                    </Form.Item>
                </div>

                <div className="col-md-3">
                    <Form.Item
                        name="reference_no"
                        label="Voucher No#"
                        rules={[
                            {
                                required: true,
                                message: "Enter voucher number"
                            },
                        ]}
                    >
                        <Input readOnly={true} className="gx-mb-3 gx-w-100 readonly"
                               placeholder="Enter a reference number"/>
                    </Form.Item>
                </div>

                <div className="col-md-3">
                    <Form.Item
                        name="payment_method"
                        label="Payment Method"
                        initialValue={2}
                        rules={[
                            {
                                required: true,
                                message: "Select payment method"
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Select a payable account"
                            optionFilterProp="children"
                            onChange={onPaymentMethodChange}
                            allowClear={true}
                            filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                        >
                            {
                                PaymentMethod.map((items, index) =>
                                    <Option key={++index} value={items.id}>{items.name}</Option>
                                )
                            }
                        </Select>
                    </Form.Item>
                </div>

                {
                    isCash === false &&
                    <div className="col-md-3">
                        <Form.Item
                            name="bank_id"
                            label="Bank"
                            rules={[
                                {
                                    required: false,
                                    message: "Select a bank"
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select a bank"
                                optionFilterProp="children"
                                onChange={onBankChange}
                                filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                            >
                                {
                                    BankName.map((items, index) =>
                                        <Option key={++index} value={items.bank_id}>{items.name}</Option>
                                    )
                                }
                            </Select>
                        </Form.Item>
                    </div>
                }

                <div className="col-md-3" id="bankaccount">
                    <Form.Item
                        name="bank_account_id"
                        label="Bank Account/Cash Account"
                        rules={[
                            {
                                required: true,
                                message: "Select a bank account"
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Select a bank account"
                            optionFilterProp="children"
                            onChange={onBankAccountChange}
                            allowClear={true}
                            filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                        >
                            {
                                isCash ?
                                    cashaccount.map((items, index) =>
                                        <Option key={++index} value={items.id}>{items.name}</Option>
                                    )
                                    :
                                    // bankaccounts.map((items, index) =>
                                    filteredBankAcocunt.map((items, index) =>
                                        <Option key={++index}
                                                value={items.id}>{items.account_no}-{items.account_name}({items.bank_name})</Option>
                                    )
                            }
                        </Select>
                    </Form.Item>
                    {
                        !isCash && <p style={{marginLeft: "14px", color: "#072f4c"}}>Total Balance
                            Is: {CisUI().getCurrencyFormated1(bankAccountBalance)}</p>
                    }
                </div>

                <div className="col-md-3" id="currency">
                    <Form.Item
                        name="currency"
                        label="Currency"
                        rules={[
                            {
                                required: true,
                                message: "Select a currency"
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Select a bank account"
                            optionFilterProp="children"
                            onChange={(e) => setCurrency(e)}
                            allowClear={true}
                            filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                        >
                            {/*<Option value="USD">US Dollar</Option>*/}
                            {/*<Option value="GHC">Ghanaian Cedi</Option>*/}
                            {
                                // console.log("add", AllCurrency)
                                AllCurrency?.map((item, index) =>
                                    <Option value={item?.value}>{item?.name}</Option>
                                )
                            }
                        </Select>
                    </Form.Item>
                </div>

                {
                    currency !== 'GHC' && (
                        <div className="col-md-3" id="currency">
                            <Form.Item
                                name="conversion_rate"
                                label="Conversion Rate"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter a conversion rate"
                                    },
                                ]}
                            >
                                <InputNumber onChange={(e) => setConversionRate(e)}  className="gx-w-100"
                                             placeholder="Conversion Rate"/>
                            </Form.Item>
                        </div>
                    )
                }

                <div className="col-md-3">
                    <Form.Item
                        name="check_no"
                        label="Check No#"
                        initialValue={polist.remark}
                        rules={[
                            {
                                required: false,
                                message: "Enter check no"
                            },
                        ]}
                    >
                        <Input placeholder="Enter check/reference no"/>
                    </Form.Item>
                </div>

                <div className="col-md-3">
                    <Form.Item
                        name="notes"
                        label="Remark/Memo"
                        initialValue={podata.notes}
                        rules={[
                            {
                                required: false,
                                message: "Enter something here"
                            },
                        ]}
                    >
                        <TextArea placeholder="Enter something here" maxLength={200}/>
                    </Form.Item>
                </div>

                {
                    showChequeCleared &&
                        <div className="col-md-2 col-sm-4">
                            <Form.Item
                                name="check_status"
                                label="Cheque Cleared?"
                                initialValue={polist.check_status}
                                valuePropName="Yes"
                                rules={[
                                    {
                                        required: false,
                                        message: "Enter something here"
                                    },
                                ]}
                            >
                                <Checkbox checked={checkStatus} onChange={onCheckChange} value={checkStatus}/>
                            </Form.Item>
                        </div>
                }

                <div className="col-md-3 col-sm-4">
                    <Form.Item
                        name="is_cit"
                        label="Apply For Cash In Transit?"
                        // initialValue={polist.check_status}
                        // valuePropName="Yes"
                        rules={[
                            {
                                required: false,
                                message: "Enter something here"
                            },
                        ]}
                    >
                        <Checkbox onChange={(e) => handleCIT(e)} checked={isCIT} />
                    </Form.Item>
                </div>

            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6">
                            <h2>Voucher Items</h2>
                        </div>
                        {/*<div className="col-md-6" style={{textAlign: "right"}}>*/}
                        {/*    <a className="btn btn-primary" onClick={handleAddRow}>Add More</a>*/}
                        {/*</div>*/}
                    </div>
                    <div style={{minWidth: "800px", overflowX: "scroll"}}>
                        <table id="itemtable" className="ptable table table-bordered">
                            <thead>
                            <tr>
                                <th></th>
                                <th>GL Code / Account</th>
                                <th style={{ display: "flex", justifyContent: "space-between" }}>
                                    Beneficiary
                                    {
                                        isShowAddButton &&
                                        // <Button type="info" style={{ marginTop: "24px", padding: "3px 10px 10px"}} >
                                        // <Tooltip title="Click here to add data.">
                                        //     <PlusCircleOutlined  onClick={() => history.push(buttonURL)}/>
                                        // </Tooltip>
                                        // </Button>

                                        <Tooltip title="Click here to add data.">
                                            <PlusCircleOutlined onClick={() => {
                                                if (buttonURL === "/vendor/newvendorinfo") {
                                                    setVendorModalVisible(true);
                                                } else {
                                                    setCustomerModalVisible(true);
                                                }
                                            }}/>
                                        </Tooltip>
                                    }
                                </th>
                                <th style={{width: '300px'}}>Item Description</th>
                                {
                                    voucherType === "Receipt" ? <th style={{width: '100px'}}>Receipt</th> :
                                        <th>Payment</th>
                                }
                            <th style={{width: '120px'}}>Attachment</th>
                        </tr>
                        </thead>
                        <tbody>
                        {state.rows.map((item, idx) => (
                            <tr id="addr0" key={idx}>
                                <td style={{width : '30px'}}>
                                    {
                                        item.id > 0 ? <>
                                            <Popconfirm
                                                placement="topLeft"
                                                title={"Are you sure you want to delete this line?"}
                                                // description={"Are you sure you want to delete this line?"}
                                                onConfirm={() => onLineDelete(item.id)}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <a href="#" className="btn btn-primary btn-circle"><i className="fa fa-trash"></i></a>
                                            </Popconfirm>
                                        </> : <a onClick={handleRemoveRow(idx)} className="btn btn-primary btn-circle"><i className="fa fa-trash"></i></a>
                                    }
                                </td>
                                <td>
                                    <Select
                                        showSearch
                                        placeholder="Select account"
                                        optionFilterProp="children"
                                        style={{width : '100%'}}
                                        value={item.account_id}
                                        onChange={ItemCellChange(idx,"account_id")}
                                        filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                    >
                                        {
                                            mainaccount.map((items, index) =>
                                                <Option key={++index} value={items.id}>{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                    <br/> <br/>
                                    {
                                        item.sub_account_id > 0 ?
                                            <Select
                                                showSearch
                                                placeholder="Select a sub account"
                                                optionFilterProp="children"
                                                style={{width : '100%'}}
                                                value={item.sub_account_id}
                                                onChange={ItemCellChange(idx,"sub_account_id")}
                                                filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                            >
                                                {
                                                    item.subaccounts.map((items, index) =>
                                                        <Option key={++index} value={items.id}>{items.name}</Option>
                                                    )
                                                }
                                            </Select> : item.subaccounts.length > 0 ? <>
                                                <Select
                                                    showSearch
                                                    placeholder="Select a sub account"
                                                    optionFilterProp="children"
                                                    style={{width : '100%'}}
                                                    value={item.sub_account_id}
                                                    onChange={ItemCellChange(idx,"sub_account_id")}
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        item.subaccounts.map((items, index) =>
                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </> : <></> }
                                </td>

                                <td>
                                    <Select
                                        showSearch
                                        placeholder="Select a beneficiary source"
                                        optionFilterProp="children"
                                        style={{width : '100%'}}
                                        value={item.beneficiary_source}
                                        onChange={ItemCellChange(idx,"beneficiary_source")}
                                        filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                    >
                                        {
                                            Benificiary.map((items, index) =>
                                                <Option key={++index} value={items.id}>{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                    <br /> <br />
                                    <Select
                                        showSearch
                                        placeholder="Select a beneficiary"
                                        optionFilterProp="children"
                                        style={{width : '100%'}}
                                        value={item.beneficiary_id}
                                        onChange={ItemCellChange(idx,"beneficiary_id")}
                                        filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                    >
                                        {
                                            item.beneficiary.map((items, index) =>
                                                <Option key={++index} value={items.id}>{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                </td>

                                <td>
                                    <input className="form-control" placeholder="Enter Item Description" name="description" value={state.rows[idx].description} onChange={ItemCellChange(idx)}  />
                                </td>
                                {/*{*/}
                                {/*    voucherType === "Receipt" ?*/}
                                {/*        <td style={{width : '100px'}}><input type="number" className="form-control text-right" style={voucherType === 'Payment' ? {color: "#545454", textAlign : 'right'} : {color: "green" , textAlign : 'right'}} placeholder="Receipt" name="amount" value={state.rows[idx].amount} onChange={ItemCellChange(idx)}  /></td>*/}
                                {/*        : <td style={{width : '100px'}}><input type="number" className="form-control text-right" style={voucherType === 'Payment' ? {color: "#545454", textAlign : 'right'} : {color: "green" , textAlign : 'right'}} name="amount" placeholder="Payment" value={state.rows[idx].amount} onChange={ItemCellChange(idx)}  /></td>*/}
                                {/*}*/}
                                {
                                    voucherType === "Receipt" ?
                                        <td style={{width: '150px'}}>
                                            <input type="number" className="form-control text-right"
                                                   style={voucherType === 'Payment' ? {
                                                       color: "#545454",
                                                       textAlign: 'right'
                                                   } : {color: "green", textAlign: 'right'}} placeholder="Receipt"
                                                   name="amount" value={state.rows[idx].amount}
                                                   onChange={ItemCellChange(idx)}/>
                                            {currency !== 'GHC' && <span style={{ color: "green" }}>Amount In GHC: {CisUI().getCurrencyFormated1(item.amount_in_ghc)}</span>}
                                        </td>
                                        :
                                        <td style={{width: '150px'}}>
                                            <input type="number" className="form-control text-right"
                                                   style={voucherType === 'Payment' ? {
                                                       color: "#545454",
                                                       textAlign: 'right'
                                                   } : {color: "green", textAlign: 'right'}} name="amount"
                                                   placeholder="Payment" value={state.rows[idx].amount}
                                                   onChange={ItemCellChange(idx)}/>
                                            {currency !== 'GHC' && <span style={{ color: "#072f4c" }}>Amount In GHC: {CisUI().getCurrencyFormated1(item.amount_in_ghc)}</span>}
                                        </td>
                                }
                                <td>
                                    <div style={{display: "flex", columnGap: "10px"}}>
                                        <Upload data={
                                            {
                                                file: formData,
                                                type: "manyvouher",
                                                file_id: fileUID,
                                                row_id: item.id,
                                                line_index: idx
                                            }
                                        } {...uplod}>
                                            <Button icon={<UploadOutlined/>}></Button>
                                        </Upload>
                                        {
                                            state.rows[idx]?.attachments?.length > 0 &&
                                            <Popover placement="topLeft" content={
                                                <>
                                                    {
                                                        state.rows[idx]?.attachments?.map((item, index) =>
                                                            // <a href={fileserver+item.location} target="_blank" style={{ display: "block", padding: "5px"}}>
                                                            <a onClick={() => showFileURL(item?.location)} style={{ display: "block", padding: "5px" }}>
                                                                <i className="fas fa-folder-open"/> {item?.file_name}
                                                            </a>
                                                        )
                                                    }
                                                </>
                                            } title="All Attachments">
                                                    <a className="btn btn-primary btn-circle">
                                                        <i className="fas fa-link"/>
                                                    </a>
                                            </Popover>
                                        }
                                    </div>
                                    
                                </td>
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        <tr>
                        <td colSpan={2}>
                                <a className="btn btn-primary" onClick={handleAddRow}><i className={`fa fa-plus`} style={{ marginRight: '7px'}}></i>Add More</a>
                            </td>
                            <td style={{textAlign: 'right', fontWeight : 'bold'}} colSpan={2}>
                                Total

                                { currency !== 'GHC' &&
                                    <>
                                        <hr/>
                                        <span>Total In GHC: </span>
                                    </>
                                }
                            </td>
                            {/*{*/}
                            {/*    voucherType === "Receipt" ?*/}
                            {/*        <td style={{textAlign : 'right', fontWeight : 'bold'}}>{CisUI().getCurrencyFormated1(bill.totalReceipt || 0)}</td>*/}
                            {/*        :<td style={{textAlign : 'right', fontWeight : 'bold'}}>{CisUI().getCurrencyFormated1(bill.totalReceipt || 0)}</td>*/}
                            {/*}*/}
                            {
                                voucherType === "Receipt" ?
                                    <td style={{textAlign: 'right', fontWeight: 'bold'}}>
                                        {
                                            currency !== 'GHC' ?
                                                <>
                                                    {/*{CisUI().getUSCurrencyFormated(bill.totalReceipt || 0)}*/}
                                                    {CisUI().getCurrencyFormatWithSymbol(currency, bill.totalReceipt || 0)}
                                                    <hr/>
                                                    {CisUI().getCurrencyFormated1(totalInGHC || 0)}
                                                </>
                                                :
                                                CisUI().getCurrencyFormated1(bill.totalReceipt || 0)
                                        }
                                        {}
                                    </td>
                                    : <td style={{textAlign: 'right', fontWeight: 'bold'}}>
                                        {
                                            currency !== 'GHC' ?
                                                <>
                                                    {/*{CisUI().getUSCurrencyFormated(bill.totalReceipt || 0)}*/}
                                                    {CisUI().getCurrencyFormatWithSymbol(currency, bill.totalReceipt || 0)}
                                                    <hr/>
                                                    {CisUI().getCurrencyFormated1(totalInGHC || 0)}
                                                </>
                                                :
                                                CisUI().getCurrencyFormated1(bill.totalReceipt || 0)}
                                    </td>
                            }
                        </tr>
                        </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )

    const runData = () => {

    }
    console.log("loade", loaded)

    return (
        <Card title={<IntlMessages id={"Multiple Voucher Edit"}/>} extra={
            isEdit === 1
                ? CisUI().addAction('../../' + jsonfile.urls.list)
                : CisUI().addAction('../' + jsonfile.urls.list)
        }>
            {CisUI().showLoading}

            <Form
                form={form}
                {...CisUI().formItemLayout}
                name="input"
                ref={formRef}
                className="ant-advanced-search-form"
                onFinish={onFinish}
                initialValues={{remember: true}}
            >
                {
                    loaded ? formField : <></>
                }

                <div onLoad={OrderDetails}></div>
                <div className="row">
                    {
                        loaded ?
                            <div className="col-md-12" style={{textAlign: 'center', marginTop: '30px'}}>
                                <Button id="submitbutton" type="primary" htmlType="submit">
                                    Save
                                </Button>
                                <Button type="info" onClick={() => history.goBack()}>Cancel</Button>
                            </div>
                            : <h4 style={{textAlign: "center", color: "red"}}>Please wait ...</h4>
                    }
                </div>

            </Form>

            <CreateCustomerModal
                visible={customerModalVisible}
                onClose={() => {
                    setCustomerModalVisible(false);
                    setAddModalRowIdx(null);
                }}
                onSuccess={handleCustomerCreated}
            />
            <CreateVendorModal
                visible={vendorModalVisible}
                onClose={() => {
                    setVendorModalVisible(false);
                    setAddModalRowIdx(null);
                }}
                onSuccess={handleVendorCreated}
            />
        </Card>
    );
};

export default MVoucherEdit;